'use client';

import { createContext, useContext, useState, type ReactNode } from 'react';

type ShareModalContextType = {
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
};

const ShareModalContext = createContext<ShareModalContextType>({
  isModalOpen: false,
  openModal: () => {},
  closeModal: () => {}
});

type ShareModalProviderProps = {
  children: ReactNode;
};

export const ShareModalProvider = ({ children }: ShareModalProviderProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return <ShareModalContext.Provider value={{ isModalOpen, openModal, closeModal }}>{children}</ShareModalContext.Provider>;
};

export const useModal = () => useContext(ShareModalContext);
